import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {TrackingService,MessageService} from "@services";
import {AppBaseComponent} from "@utils";

import Swal from "sweetalert2";

@Component({
  selector: 'app-reports-revoked-revocatoria',
  templateUrl: './reports-revoked-revocatoria.component.html',
  styleUrls: ['./reports-revoked-revocatoria.component.scss']
})
export class ReportsRevokedRevocatoriaComponent extends AppBaseComponent implements OnInit {

  @Input() idTramiteActual: any;

  revocatoriaForm: FormGroup;

  sending: boolean = false;

  constructor(private fb: FormBuilder,
              private trackingService: TrackingService,
              private popupAlert: MessageService)
  {
    super();
    this.revocatoriaForm = this.fb.group({
      observation: ['', [Validators.required, Validators.minLength(5)]]
    })
  }

  ngOnInit(): void {
    console.log("estoy en tramiteActual", this.idTramiteActual)
  }

  revocar(): void {

    if (!this.revocatoriaForm.valid) {
      this.popupAlert.errorAlert(
        `Por favor, revise el formulario de seguimiento, hay datos invalidos y/o incompletos.`,
        4000
      );
      console.log("VALORES DEL FORM")
      console.log(this.revocatoriaForm.value);
      console.log("ERRORES DEL FORM")
      console.log(super.getAllErrors(this.revocatoriaForm));
      this.revocatoriaForm.markAllAsTouched();
      return;
    }

    let tracking = {
      "statusId": "13",
      "observation": this.revocatoriaForm.get('observation').value,
      "procedureRequestId": this.idTramiteActual
    }

    Swal.fire({
      title: 'Anuncio',
      text: "¿Está seguro de revocar la licencia para la prestación de servicios en SST?",
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.sending = true;
        // tslint:disable-next-line: no-unused-variable
        this.trackingService.saveTracking(tracking).subscribe(resp => {
          this.sending = false;
          console.log("TRACKING GUARDADO");
          console.log(tracking)
          console.log(resp);
          this.popupAlert.successAlert(
            'Su seguimiento se ha registrado satisfactoriamente!',
            4000);
          location.reload();
        }, error => {
          this.sending = false;
          console.log("TRACKING FALLIDO");
          console.log(tracking)
          this.popupAlert.errorAlert(
            'Ocurrió un error al guardar el seguimiento.',
            4000);
          console.log(error);
        });
      }
    });

  }

  getErrorMessage(field: string): string {
    let message;

    if(this.isTouchedField(this.revocatoriaForm, field))
    {
      if( this.revocatoriaForm?.get(field).hasError('required'))
      {
        message = 'Es requerido';
      }
      else if(this.revocatoriaForm?.get(field).hasError('minlength'))
      {
        message = `Debe tener al menos 5 caracteres`;
      }
    }


    return message;
  }

}
